/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerLeftDownDouble = createReactComponent("outline", "corner-left-down-double", "IconCornerLeftDownDouble", [["path", { "d": "M18 4h-6a3 3 0 0 0 -3 3v7", "key": "svg-0" }], ["path", { "d": "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4", "key": "svg-1" }]]);

export { IconCornerLeftDownDouble as default };
//# sourceMappingURL=IconCornerLeftDownDouble.mjs.map
